export const appTableData: { displayValue: string, value: string }[] = [
    { displayValue: 'Client', value: 'm_client' },
    { displayValue: 'Group', value: 'm_group' },
    { displayValue: 'Center', value: 'm_center' },
    { displayValue: 'Office', value: 'm_office' },
    { displayValue: 'Loan Account', value: 'm_loan' },
    { displayValue: 'Saving Account', value: 'm_savings_account' },
    { displayValue: 'Loan Product', value: 'm_product_loan' },
    { displayValue: 'Savings Product', value: 'm_savings_product' },
    { displayValue: 'Share Product', value: 'm_share_product' }
  ];

export const entitySubTypeData: { displayValue: string, value: string }[] = [
    { displayValue: 'Person', value: 'Person' },
    { displayValue: 'Entity', value: 'Entity' },
  ];

export const savingsSubTypeData: { displayValue: string, value: string }[] = [
    { displayValue: 'Savings Product', value: 'Savings Product' },
    { displayValue: 'Fixed Deposit', value: 'Fixed Deposit' },
    { displayValue: 'Recurring Deposit', value: 'Recurring Deposit' },
  ];
